import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"

import { useState } from "react"
import PresencesList from "./presencesList"
//import { useGetGroupsQuery } from "../groups/groupsApiSlice"
function PresencesListFilter() {
    useTitle('geshtop-Exercise: Presences List')
    const {groupId} = useParams()
  const[txt,setTxt] = useState('')
 

    const content =(<>
    <div className="filter-form">
        <div className="filter-form-item">
            <div className="form-input-container">
            <input
                    className={`form__input`}
                    id="txt"
                    placeholder="הכנס שם שיעור"
                    name="txt"
                    type="text"
                    autoComplete="off"
                    value={txt}
                    onChange={e=>setTxt(e.target.value)}
                />
             </div>
        </div>

    </div>
  <PresencesList txt={txt}  /> 

</> ) 
  return content;
}

export default PresencesListFilter